<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você poderá definir o relatório financeiro Stars do fundo. Ao
              definir algum valor ele ficaria visível para os investidores
              vinculados ao fundo.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row mb-4">
        <div class="col-12 vld-parent" ref="fund_container">
          <card shadow footerClasses="pt-2 pb-3 text-center">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">
                    Fundo de Investimentos
                    <span class="text-warning">STARS</span>
                  </h3>
                </div>
              </div>
            </div>
            <template>
              <div class="row text-center">
                <div class="col-md-4">
                  <img src="/img/pages/fund.png" width="100" alt="..." />
                  <h3 class="mt-2">{{ fund.tag }}</h3>
                  <badge type="info">{{ getTypeLabel(fund.type) }}</badge>
                </div>
                <div class="col-md-8">
                  <div
                    class="card-profile-stats d-flex justify-content-center small pb-0 mb-1 pt-1"
                  >
                    <div>
                      <span class="heading">{{ fund.batches || "-" }}</span>
                      <span class="description">Batches</span>
                    </div>
                    <div>
                      <span class="heading">{{ formatValue(fund.value) }}</span>
                      <span class="description">Valor</span>
                    </div>
                    <div>
                      <span class="heading">{{
                        fund.number_investors || "-"
                      }}</span>
                      <span class="description">Investidores</span>
                    </div>
                  </div>
                  <h4 class="mt-4">
                    <div class="h5 font-weight-300 mb-1">
                      <i class="ni ni-pin-3 mr-2"></i>{{ fund.city || "..." }},
                      {{ fund.state || "..." }}
                    </div>
                  </h4>
                  <h4>
                    Duração:
                    <span class="font-weight-light">
                      {{ formatDate(fund.start_date, "L") || "..." }} até
                      {{ formatDate(fund.end_date, "L") || "..." }}
                    </span>
                  </h4>
                </div>
              </div>
            </template>
            <div slot="footer">
              <base-button
                class="mt-2"
                type="white"
                @click="$router.push(`/admin/fundos/${fund.id}/editar`)"
                ><i class="fas fa-edit text-info mr-2"></i>Editar
                fundo</base-button
              >
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <base-button type="primary" :custom="true" @click="openModalNew"
            >Adicionar novo relatório</base-button
          >
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <hr class="my-4" />
          <h6 class="heading-small text-muted mb-3">
            Relatórios financeiros vinculados ao fundo
          </h6>
        </div>
      </div>
      <div class="col-12 vld-parent" ref="report_container">
        <p v-if="!reports.length" class="text-center">
          <badge type="primary"
            >Ainda não existem relatórios vinculados ao fundo</badge
          >
        </p>
        <tabs
          v-else
          fill
          class="flex-column flex-md-row"
          tabNavWrapperClasses="pt-0"
          type="primary"
        >
          <card shadow bodyClasses="px-2 py-3">
            <tab-pane
              :title="report.title"
              v-for="report in reports"
              :key="report.title"
            >
              <span slot="title">
                <i class="fas fa-coins mr-2"></i>
                {{ report.title }}
              </span>
              <div>
                <quill-editor
                  v-model="report.report"
                  :options="editorReadOnly"
                  disabled="disabled"
                >
                </quill-editor>
                <p class="description text-muted text-right mb-0">
                  Relatório adicionado em
                  {{ formatTimestamp(report.created_at) }}. Última atualização
                  em {{ formatTimestamp(report.updated_at) }}.
                </p>
              </div>
              <div class="text-center">
                <hr class="mt-2 mb-3" />
                <base-button
                  type="white"
                  title="Editar relatório"
                  icon="fas fa-edit text-info"
                  @click="openModalEdit(report)"
                ></base-button>
                <base-button
                  type="white"
                  title="Remover relatório"
                  icon="fas fa-trash text-red"
                  @click="openModalRemove(report)"
                ></base-button>
              </div>
            </tab-pane>
          </card>
        </tabs>
      </div>
    </div>
    <modal
      :show.sync="modals.new.show"
      modal-classes="modal-dialog-centered modal-xl"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Adicionar novo relatório
      </h6>
      <div class="vld-parent" ref="modals_new">
        <div class="col-12 text-center">
          <i class="fa fa-coins fa-3x"></i>
          <h4 class="heading mt-4">Novo relatório financeiro</h4>
        </div>
        <div class="col-lg-12">
          <base-input
            label="Título do relatório"
            v-model="model.title"
            placeholder="Ex. 1º trimeste, 2º trimeste, ..."
          />
        </div>
        <div class="col-lg-12">
          <label class="form-control-label d-block">
            Relatório
            <base-button
              size="sm"
              type="link"
              class="p-0 m-0 ml-2 float-right"
              @click="addDefaultReport(model)"
            >
              Adicionar template padrão
            </base-button>
          </label>
          <div class="fr-container-edditable">
            <quill-editor v-model="model.report" :options="editorEdittable">
            </quill-editor>
          </div>
        </div>
        <div class="col-12 text-center mt-4">
          <base-alert type="danger" v-if="modals.new.error">{{
            modals.new.error
          }}</base-alert>
        </div>
      </div>
      <div slot="footer">
        <base-button
          type="primary"
          @click="handleStoreReport()"
          :disabled="!model.title || !model.report"
        >
          Criar relatório
        </base-button>
      </div>
    </modal>
    <modal
      :show.sync="modals.edit.show"
      modal-classes="modal-dialog-centered modal-xl"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Editar relatório
      </h6>
      <div class="vld-parent" ref="modals_edit">
        <div class="col-12 text-center">
          <i class="fa fa-coins fa-3x"></i>
          <h4 class="heading mt-4">Editar relatório financeiro</h4>
        </div>
        <div class="col-lg-12">
          <base-input
            label="Título do relatório"
            v-model="modals.edit.model.title"
            placeholder="Ex. 1º trimeste, 2º trimeste, ..."
          />
        </div>
        <div class="col-lg-12">
          <label class="form-control-label d-block">
            Relatório
            <base-button
              size="sm"
              type="link"
              class="p-0 m-0 ml-2 float-right"
              @click="addDefaultReport(modals.edit.model)"
            >
              Adicionar template padrão
            </base-button>
          </label>
          <div class="fr-container-edditable">
            <quill-editor
              v-model="modals.edit.model.report"
              :options="editorEdittable"
            >
            </quill-editor>
          </div>
        </div>
        <div class="col-12 text-center mt-4">
          <base-alert type="danger" v-if="modals.edit.error">{{
            modals.edit.error
          }}</base-alert>
        </div>
      </div>
      <div slot="footer">
        <base-button
          type="primary"
          @click="handleUpdateReport()"
          :disabled="!modals.edit.model.title || !modals.edit.model.report"
        >
          Atualizar relatório
        </base-button>
      </div>
    </modal>
    <modal
      :show.sync="modals.remove.show"
      gradient="dark"
      modal-classes="modal-danger modal-dialog-centered"
      body-classes="pb-2"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modals_remove">
        <div class="py-3 text-center">
          <i class="fa fa-exclamation-circle fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir o relatório
            <span class="text-danger">{{ modals.remove.report.title }}</span
            >?
          </h4>
          <p class="mt-3 mb-0">As informações do relatório serão perdidas.</p>
        </div>
        <div class="col-12 text-center" v-if="modals.remove.error">
          <base-alert type="danger"
            >Ocorreu um erro ao remover o relatório</base-alert
          >
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="l-auto"
          @click="modals.remove.show = false"
        >
          Voltar
        </base-button>
        <base-button
          type="white"
          class="text-danger"
          @click="handleRemoveReport"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import api from "@/services/api.js";

export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      model: {
        title: "",
        report: "",
      },
      fund: "",
      reports: [],
      modals: {
        new: {
          show: false,
          error: "",
        },
        edit: {
          show: false,
          report: "",
          model: {
            title: "",
            report: "",
          },
          error: "",
        },
        remove: {
          show: false,
          report: "",
          error: "",
        },
      },
      editorEdittable: {
        placeholder: "Escreva aqui...",
      },
      editorReadOnly: {
        placeholder: "N/A",
        readOnly: true,
        theme: "bubble",
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.fund_container,
      width: 90,
      height: 90,
      opacity: 0,
    });
    try {
      const { data } = await api.get(`/funds/${this.$route.params.id}`);
      this.fund = data;
      await this.fetchReports();
    } catch (e) {
      this.$toasted.error("Ocorreu ao recuperar as informações do fundo");
      this.$router.push("/admin/fundos");
    }
    loader.hide();
  },
  methods: {
    async fetchReports() {
      const loader = this.$loading.show({
        container: this.$refs.report_container,
        width: 90,
        height: 90,
        opacity: 0,
      });
      const { data } = await api.get(`/funds/${this.fund.id}/reports`);
      this.reports = data;
      loader.hide();
    },
    openModalNew() {
      this.modals.new.error = "";
      this.modals.new.show = true;
    },
    openModalEdit(report) {
      this.modals.edit.model.title = report.title;
      this.modals.edit.model.report = report.report;
      this.modals.edit.report = report;
      this.modals.edit.error = "";
      this.modals.edit.show = true;
    },
    openModalRemove(report) {
      this.modals.remove.error = "";
      this.modals.remove.report = report;
      this.modals.remove.show = true;
    },
    async handleStoreReport() {
      this.modals.new.error = "";
      const loader = this.$loading.show({
        container: this.$refs.modals_new,
        opacity: 0,
        width: 140,
        height: 140,
      });
      try {
        const { data } = await api.post(
          `/funds/${this.fund.id}/reports`,
          this.model
        );
        this.reports.push(data);
        this.modals.new.show = false;
        this.$toasted.show("Relatório salvo com sucesso");
        this.model.title = this.model.report = "";
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao salvar as informações");
        this.modals.new.error =
          "Ocorreu um erro ao salvar o relatório. Tente novamente.";
      }
      loader.hide();
    },
    async handleUpdateReport() {
      this.modals.edit.error = "";
      const loader = this.$loading.show({
        container: this.$refs.modals_edit,
        opacity: 0,
        width: 140,
        height: 140,
      });
      try {
        await api.put(
          `/funds/${this.fund.id}/reports/${this.modals.edit.report.id}`,
          this.modals.edit.model
        );
        this.modals.edit.report.title = this.modals.edit.model.title;
        this.modals.edit.report.report = this.modals.edit.model.report;
        this.modals.edit.show = false;
        this.$toasted.show("Relatório atualizado com sucesso");
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao atualizar as informações");
        this.modals.edit.error =
          "Ocorreu um erro ao atualizar o relatório. Tente novamente.";
      }
      loader.hide();
    },
    async handleRemoveReport() {
      this.modals.remove.error = false;
      const loader = this.$loading.show({
        container: this.$refs.modals_remove,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(
          `/funds/${this.modals.remove.report.fund_id}/reports/${this.modals.remove.report.id}`
        );
        this.$toasted.show("Relatório removido com sucesso");
        this.reports = this.reports.filter((report) => {
          return report.id !== this.modals.remove.report.id;
        });
        this.modals.remove.show = false;
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao remover o relatório.");
        this.modals.remove.error = true;
      } finally {
        loader.hide();
      }
    },
    getTypeLabel(fundType) {
      const separator = fundType === "Misto" ? "" : "de";
      return `Fundo ${separator} ${fundType}`;
    },
    addDefaultReport(obj) {
      // eslint-disable-next-line no-useless-escape
      obj.report = `<p><strong style=\"color: rgb(34, 34, 34);\">• </strong><strong>Total integralizado</strong>.........................................R$</p><p><strong style=\"color: rgb(34, 34, 34);\">• </strong><strong>Despesas comerciais</strong>....................................R$</p><p><strong style=\"color: rgb(34, 34, 34);\">• </strong><strong>Despesas administrativas</strong>.............................R$</p><p><strong style=\"color: rgb(34, 34, 34);\">• </strong><strong>Outras despesas</strong>............................................R$</p><p><strong style=\"color: rgb(34, 34, 34);\">• </strong><strong>Investimento startups</strong>....................................R$</p><p class=\"ql-indent-1\"><span style=\"color: rgb(32, 33, 36);\">→ </span><strong>Investimento startup 1</strong>......................R$</p><p class=\"ql-indent-1\"><span style=\"color: rgb(32, 33, 36);\">→ </span><strong>Investimento startup 2</strong>......................R$</p><p class=\"ql-indent-1\"><span style=\"color: rgb(32, 33, 36);\">→ </span><strong>Investimento startup 3</strong>......................R$</p><p><strong style=\"color: rgb(34, 34, 34);\">• </strong><strong>Resultado final</strong>...............................................R$</p><p><strong style=\"color: rgb(34, 34, 34);\">• </strong><strong>Resultado acumulado</strong>....................................R$</p>`;
    },
  },
  computed: {
    orderedReports() {
      const compareFunction = function (a, b) {
        return a.title > b.title ? 1 : -1;
      };
      const reports = [...this.reports].sort(compareFunction);
      return reports;
    },
  },
};
</script>
<style>
p > strong {
  font-weight: bold !important;
}

.fr-container-edditable .quill-editor .ql-container,
.fr-container-edditable .quill-editor .ql-container .ql-editor {
  min-height: 10rem;
  width: 100%;
}

.fr-container-read-only .quill-editor .ql-container,
.fr-container-read-only .quill-editor .ql-container .ql-editor {
  max-height: 400px;
  width: 100%;
}
</style>
